<template>
  <div>
    <p v-if="isDocumentsLoading" class="p-4 text-subtle">Hämtar dokument...</p>

    <SectionCard v-else title="Dokument">
      <AppTable>
        <thead>
          <tr>
            <th>Dokumenttyp</th>
            <th>Tillhör</th>
            <th>Filtyp</th>
            <th>Skapat</th>
            <th></th>
          </tr>
        </thead>
        <tbody v-if="documents.length">
          <AppTableRow
            v-for="document in documents"
            :key="document.id"
            class="document-row"
            @click="openDocument(document)"
          >
            <AppTableCell>{{ translateDocumentType(document.type) }}</AppTableCell>
            <AppTableCell>{{ getDocumentRelation(application?.applicants, document.relations) }}</AppTableCell>
            <AppTableCell>{{ document.fileType.ext.toUpperCase() }}</AppTableCell>
            <AppTableCell nowrap>{{ formatDateIfValid(document.createdAt) }}</AppTableCell>
            <AppTableCell action>
              <span @click.stop>
                <AppButton
                  icon
                  small
                  :loading="openingDocumentId === document.id"
                  :aria-label="`Visa ${translateDocumentType(document.type)}`"
                  title="Visa"
                  @click="openDocument(document)"
                >
                  <SvgIcon :path="mdiMagnify" size="18" />
                </AppButton>
              </span>
            </AppTableCell>
          </AppTableRow>
        </tbody>

        <tbody v-else>
          <AppTableRow>
            <AppTableCell colspan="5" class="text-center">Inga dokument.</AppTableCell>
          </AppTableRow>
        </tbody>
      </AppTable>
    </SectionCard>
  </div>
</template>

<script setup lang="ts">
import { watch } from 'vue'
import { mdiMagnify } from '@mdi/js'
import { formatDateIfValid } from '@staff/shared'
import { AppButton, AppTable, AppTableCell, AppTableRow, notify, SectionCard, SvgIcon } from '@staff/ui'

import { useApplicationDocumentsContext, getDocumentRelation } from '@/views/application/applicationDocuments.context'
import { useMetadata } from '@/composables/useMetadata'
import { useDocumentPreview } from '@/composables/documentPreview'
import { useApplicationContext } from '../application.context'

const { application } = useApplicationContext()
const { translateDocumentType } = useMetadata()
const { openingDocumentId, openDocument } = useDocumentPreview((document) => translateDocumentType(document.type))

const { documents, isLoading: isDocumentsLoading, error: documentsError } = useApplicationDocumentsContext()

watch(documentsError, (errorMessage) => {
  if (errorMessage) {
    notify({
      type: 'error',
      title: 'Kunde inte hämta dokument',
      description: errorMessage,
      dismissable: true,
    })
  }
})
</script>
<style scoped>
.document-row {
  cursor: pointer;
}
</style>
